import { render, staticRenderFns } from "./messageGroupList.vue?vue&type=template&id=45279934"
import script from "./messageGroupList.vue?vue&type=script&lang=js"
export * from "./messageGroupList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports